<template>
  <div>
    <result-not-found v-if="result.data.length === 0" />
    <div
      v-for="(admission, admissionindex) in result.data"
      :key="`admission-item-${admissionindex}`"
    >
      <board class="mb-1 c-board" :details="admission.boardData" />
      <div
        v-for="(item, index) in admission.calloutData"
        :key="`referral-item-${index}`"
      >
        <callout
          apply-border-top
          border-top-color="#D9AE8E"
          :class="{
            'mb-3':
              !item.startDateError &&
              !item.endDateError &&
              !item.dateRangeError &&
              item.errors.length == 0,
          }"
          :controlled="true"
          :has-toggle="true"
          :opened="item.isOpen"
          @click:open="onOpenDetails(item, admissionindex, index)"
        >
          <div class="row">
            <div class="col-md-3 mt-2 c-baloonPlusNumber">
              <ballon
                :background-color="
                  `text-center font-14 border-none bg-${getStatusColor(
                    item.statusId
                  )}`
                "
                class="mt-2 p-0 font-weight-bold font-16"
                :text="item.status"
              />
              <div class="ml-4 pl-2 mt-2">
                <span
                  class="color-secondary-6 font-14 text-left font-weight-normal"
                >
                  No.
                </span>
                <label class="color-black font-16 font-weight-bold">
                  {{ item.number }}
                </label>
              </div>
            </div>

            <div class="col-12 horizontalDivider d-md-none" />

            <div class="col-md-9 py-3 px-4">
              <div class="row c-customDatePickers">
                <div class="col-md-2">
                  <div
                    v-if="item.statusId == AdmissionStatus.NoVigenteTraslado"
                    class="mb-3 mb-md-0"
                  >
                    <div class="font-weight-normal font-14 color-secondary-6">
                      Tipo:
                    </div>
                    <span class="font-weight-normal font-16 color-black">
                      {{ item.type || '-' }}
                    </span>
                  </div>
                </div>
                <div class="col-md-2 mb-3 mb-md-0">
                  <div>
                    <div class="font-weight-normal font-14 color-secondary-6">
                      Visitas:
                    </div>
                    <span class="font-weight-normal font-16 color-black">
                      {{ item.admissionVisitCount || '-' }}
                    </span>
                  </div>
                </div>
                <div class="col-md-2 mb-3 mb-md-0">
                  <div
                    v-if="item.statusId == AdmissionStatus.NoVigenteTraslado"
                  >
                    <div class="font-weight-normal font-14 color-secondary-6">
                      Fecha de Manejo:
                    </div>
                    <span class="font-weight-normal font-16 color-black">
                      {{ item.date | date }}
                    </span>
                  </div>
                </div>
                <div class="col-6 col-sm col-12 mb-3 mb-md-0">
                  <div class="font-weight-normal font-14 color-secondary-6">
                    Fecha Desde:
                  </div>
                  <custom-date-picker
                    v-model="item.startDate"
                    class="customDatePicker"
                    :disabled="!canEditVigency"
                    :error="item.startDateError ? 'error' : ''"
                    placeholder="DD/MM/YYYY"
                    @input="onDateChange(admissionindex, index, 'start')"
                  />
                </div>
                <div class="col-6 col-sm col-12 col-md-3">
                  <div class="font-weight-normal font-14 color-secondary-6">
                    Fecha Hasta:
                  </div>
                  <custom-date-picker
                    v-model="item.endDate"
                    class="customDatePicker"
                    :error="item.endDateError ? 'error' : ''"
                    placeholder="DD/MM/YYYY"
                    @input="onDateChange(admissionindex, index, 'end')"
                  />
                </div>
              </div>
              <div class="row mt-2 c-customDatePickers">
                <div class="col-md-2" />
                <div class="col-md-4 mb-3 mb-md-0">
                  <div>
                    <div class="font-weight-normal font-14 color-secondary-6">
                      Especialista de Admisión:
                    </div>
                    <span class="font-weight-normal font-16 color-black">
                      {{ item.assignmentSpecialistFullName || '-' }}
                    </span>
                  </div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                  <div>
                    <div class="font-weight-normal font-14 color-secondary-6">
                      Especialista de Servicio:
                    </div>
                    <span class="font-weight-normal font-16 color-black">
                      {{ item.admissionSpecialistFullName | '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template #edition>
            <div class="bg-gray p-2">
              <div class="bg-white rounded">
                <b-tabs
                  content-class="mt-3"
                  nav-class="custom-nav-container"
                  :no-nav-style="true"
                >
                  <b-tab active lazy title="Información General">
                    <general-info :info="item" />
                  </b-tab>

                  <b-tab
                    title="Visitas"
                    @click="onActivateVisitTabHandler(item)"
                  >
                    <visit
                      :pagination="visitHistoryPagination"
                      :visits="visitsHistoryPaginated"
                      @page-change="onVisitHistoryPageChangeHandler"
                    />
                    <pagination
                      v-if="canShowVisitHistoryPagination"
                      :data="visitHistoryPagination"
                      @pagination-go-page="onVisitHistoryPageChangeHandler"
                    />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </template>
        </callout>
        <div
          v-if="hasReferralError(item)"
          class="bg-secondary-10 p-2 rounded-bottom mb-3"
        >
          <error
            v-if="item.startDateError || item.endDateError"
            message="Favor de entrar fecha desde/hasta."
            variant="no-border"
          />
          <error
            v-if="
              item.dateEndRangeError &&
                !(item.startDateError || item.endDateError)
            "
            message="Fecha de vigencia hasta no puede ser menor a la desde."
            variant="no-border"
          />
          <error
            v-if="
              item.dateStartRangeError &&
                !(item.startDateError || item.endDateError)
            "
            message="Fecha de vigencia desde no puede ser mayor a la hasta."
            variant="no-border"
          />
          <div v-if="item.errors.length > 0">
            <error
              v-for="(errItem, errIndex) in item.errors"
              :key="`err-${errIndex}`"
              :message="errItem"
              variant="no-border"
            />
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-if="showPagination"
      :data="resultSearch.pagination"
      :show-text="true"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import ResultNotFound from '@/components/common/ResultNotFound';
import Callout from 'custom-callout';
import Ballon from 'custom-balloon';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import Error from '@/components/common/Error.vue';
import AdmissionStatus from '@/utils/shared/constants/admissionStatus';
import { GeneralInfo, Visit } from './components/tabs';
import { getVisitHistory } from '@/modules/shared/studentreferral.api';
import moment from 'moment';

export default {
  name: 'SearchResult',
  components: {
    Pagination,
    ResultNotFound,
    Callout,
    Ballon,
    CustomDatePicker,
    Error,
    GeneralInfo,
    Visit,
  },
  props: {
    resultSearch: {
      type: Object,
      default: () => ({
        data: [],
        pagination: {},
      }),
    },
    searchAcademicYearId: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data: () => ({
    result: {
      data: [],
    },
    AdmissionStatus,
    visits: [],
    visitHistoryPagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
      perPage: 5,
    },
  }),
  computed: {
    canEditVigency() {
      return this.userHasPermissions('referredmanagement.validity.edit');
    },
    showPagination() {
      return (
        this.resultSearch.data.length > 0 &&
        this.resultSearch.pagination.totalItemCount >
          this.resultSearch.pagination.perPage
      );
    },
    canShowVisitHistoryPagination() {
      return (
        this.visits.length > 0 &&
        this.visitHistoryPagination.totalItemCount >
          this.visitHistoryPagination.perPage
      );
    },
    getStatusColor() {
      return (statusId) => {
        switch (statusId) {
          case AdmissionStatus.NoVinculado:
          case AdmissionStatus.NoVigenteAlta:
          case AdmissionStatus.NoVigenteBajas:
          case AdmissionStatus.NoVigenteFinDeAnoEscolar:
          case AdmissionStatus.NoVigenteTraslado:
            return 'secondary-15';
          case AdmissionStatus.Vinculado:
          case AdmissionStatus.Admitido:
          case AdmissionStatus.ReferidoDirectorCSEE:
          case AdmissionStatus.AprobadoRemedioProvisional:
            return 'green-light';
          case AdmissionStatus.Alertas:
            return 'pink';
          case AdmissionStatus.ServicioRelacionadoActivo:
          case AdmissionStatus.Asignado:
            return 'secondary-23';
          case AdmissionStatus.ReferidoRechazado:
            return 'violet';
          default: {
            return `primary-13`;
          }
        }
      };
    },
    visitsHistoryPaginated() {
      let currentPage = this.visitHistoryPagination.currentPage;
      let pageSize = this.visitHistoryPagination.perPage;
      return this.visits.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
      );
    },
    hasReferralError() {
      return (item) =>
        item.startDateError ||
        item.endDateError ||
        item.dateStartRangeError ||
        item.dateEndRangeError ||
        item.errors.length > 0;
    },
  },
  watch: {
    resultSearch: {
      deep: true,
      handler(value) {
        this.result.data = value.data;
      },
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('on-page-change', page);
    },
    onVisitHistoryPageChangeHandler(page) {
      this.visitHistoryPagination.currentPage = page;
      this.visitHistoryPagination.totalItemCount = this.visits.length;
      this.visitHistoryPagination.pageCount = Math.ceil(
        this.visitHistoryPagination.totalItemCount /
          this.visitHistoryPagination.perPage
      );
      this.visitHistoryPagination.count = this.visitsHistoryPaginated.length;
    },
    onOpenDetails(item, admissionIndex, index) {
      item.isOpen = item.isOpen == undefined ? true : !item.isOpen;
      this.result = {
        ...this.result,
        data: this.result.data.map((x, parentIndex) => {
          if (parentIndex === admissionIndex) {
            x.calloutData = x.calloutData.map((c, childIndex) => {
              if (childIndex != index) {
                c.isOpen = false;
              }
              return c;
            });
          }
          return x;
        }),
      };
      this.$forceUpdate();
    },
    async onActivateVisitTabHandler(item) {
      if (!item.admissionId) {
        return;
      }

      const { data } = await getVisitHistory(
        item.admissionId,
        this.searchAcademicYearId
      );
      this.visits = data;
      this.onVisitHistoryPageChangeHandler(1);
    },
    onDateChange(admissionIndex, index, type) {
      let nextDay = null;
      this.result = {
        ...this.result,
        data: this.result.data.map((x, parentIndex) => {
          if (parentIndex === admissionIndex) {
            x.calloutData = x.calloutData.map((c, childIndex) => {
              if (childIndex == index) {
                c.changed = true;
                c.changeStartDate = type == 'start';
                c.changeEndDate = type == 'end';
                nextDay = moment(c.endDate)
                  .add(1, 'days')
                  .format('YYYY-MM-DD');
              } else if (childIndex == index + 1) {
                c.changed = true;
                c.changeStartDate = true;
                c.startDate = nextDay;
              }
              return c;
            });
          }
          return x;
        }),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@700&display=swap');
::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  margin-left: 20px;
  margin-right: 20px;
  .nav-item {
    .nav-link {
      font-size: 16px;
      padding-right: 100px;
      color: map-get($colors, 'gray-6');
      padding-left: 100px;
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
        font-weight: bold;
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  ::v-deep .c-iconPlusText {
    margin-bottom: 25px;
    ::v-deep .c-icon {
      width: 34px;
      height: 34px;
      border: none !important;
      margin: 0 !important;

      em {
        font-size: 15px !important;
      }
    }
    .c-icon-text {
      margin-left: 23px !important;
      font-size: 14px !important;
      font-weight: bold !important;
    }
  }

  .c-baloonPlusNumber {
    display: flex;
    align-items: center;
  }

  .horizontalDivider {
    height: 1px;
    background-color: transparentize(#727272, 0.8);

    flex: 80% 0 1;
    margin: 20px auto 0;
  }

  .c-customDatePickers {
    @media only screen and (max-width: 600px) {
      //display: flex;
      //flex-wrap: nowrap;
      ::v-deep .custom-datetime-picker-container {
        width: 100% !important;
      }
    }
  }

  ::v-deep ul.custom-nav-container {
    flex-wrap: nowrap;
    //flex-wrap: nowrap!important;

    li {
      flex: 50% 1 1;

      a {
        padding: 4px !important;
        text-align: center;
        font-size: 12px !important;
      }
    }
  }
}

.balloon-container {
  padding: 5px !important;
}

.c-board {
  ::v-deep .col-md-3.col-sm-12:first-child {
    margin-bottom: 20px;
  }
}
</style>
